import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { Phase, NavState, SettingsTab } from '../lib/types'
import { ACTIVE_YEAR } from '../lib/types'

interface AppStore {
  role: 'teacher' | 'admin'
  phase: Phase
  nav: NavState
  reviewId: string | null
  schoolYear: string
  drawerOpen: boolean
  settingsOpen: boolean
  settingsTab: SettingsTab
  assignAddStaff: boolean
  setRole: (role: 'teacher' | 'admin') => void
  setPhase: (phase: Phase) => void
  setNav: (nav: NavState) => void
  setReviewId: (id: string | null) => void
  setSchoolYear: (year: string) => void
  setDrawerOpen: (open: boolean) => void
  openSettings: (tab?: SettingsTab) => void
  closeSettings: () => void
  setAssignAddStaff: (open: boolean) => void
  goAddStaff: () => void
}

export const useAppStore = create<AppStore>()(
  persist(
    (set) => ({
      role: 'teacher',
      phase: 'fall',
      nav: { page: 'overview' },
      reviewId: null,
      schoolYear: ACTIVE_YEAR,
      drawerOpen: false,
      settingsOpen: false,
      settingsTab: 'profile',
      assignAddStaff: false,
      setRole: (role) => set({ role }),
      setPhase: (phase) => set({ phase }),
      setNav: (nav) => set({ nav, drawerOpen: false, settingsOpen: false }),
      setReviewId: (reviewId) => set({ reviewId }),
      setSchoolYear: (schoolYear) => set({ schoolYear }),
      setDrawerOpen: (drawerOpen) => set({ drawerOpen }),
      openSettings: (tab = 'profile') => set({ settingsOpen: true, settingsTab: tab, drawerOpen: false }),
      closeSettings: () => set({ settingsOpen: false }),
      setAssignAddStaff: (assignAddStaff) => set({ assignAddStaff }),
      goAddStaff: () => set({ role: 'admin', reviewId: null, nav: { page: 'assign' }, assignAddStaff: true, drawerOpen: false }),
    }),
    {
      name: 'growthlane-ui-v1',
      partialize: (s) => ({
        role: s.role,
        phase: s.phase,
        nav: s.nav,
        reviewId: s.reviewId,
        schoolYear: s.schoolYear,
      }),
    }
  )
)
